// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31U31","field":"styles_field__qxGpY","fieldCol":"styles_fieldCol__1DzOb","diffCol":"styles_diffCol__5Ydy6","diff":"styles_diff__27TR5"};